var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{directives:[{name:"show",rawName:"v-show",value:(_vm.$utils.showAsideNavigationMenu),expression:"$utils.showAsideNavigationMenu"}],class:['o-edition-section-navigation', _vm.$store.getters.getIsClientData === false
    ? 'o-edition-section-content-navigation' : '']},[_c('MoleculeEditionSectionNavigationMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }